import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import useAnalyticsConnect from './useAnalyticsConnect';

function AnalyticsConnect() {
  const {
    albatoEmbedURL,
  } = useAnalyticsConnect();

  function renderAlbatoIframe() {
    if (!albatoEmbedURL) return null;
    return (
      <iframe
        id="albato"
        src={albatoEmbedURL}
        title="Albato Integration"
        style={{
          width: '1px',
          minWidth: '100%',
          border: 'none',
          height: '1000px',
          overflow: 'hidden',
        }}
      />
    );
  }

  return (
    <React.Fragment>
      <Grid item xs={12}>
        {renderAlbatoIframe()}
      </Grid>
    </React.Fragment>
  );
}

const AnalyticsConnectObserver = observer(AnalyticsConnect);
export default AnalyticsConnectObserver;
